import React, {Component, Fragment} from "react";
import {isMobile} from './PureTools';
import {connect} from "react-redux";
import * as actions from "./actions/action";
import {AnyAction, bindActionCreators, Dispatch} from "redux";
import store, {HoveredFlightType, LocationsType, StateBaseType} from './store';
import {log, airportToCityCountry, mapData, ArcColor, NullableType} from './Tools';
import {FlightType, MAP_NEXT, SET_HOVERED_CITY} from "./actions/action";
// @ts-ignore
import {GeodesicLine} from 'react-leaflet-geodesic'
import {GOOGLE_MAP_TYPE} from "./Constants";

interface LocalStateType {
    highlight: boolean,
    mobileTouchStart: any
}

interface InputType {
    /* from parent */
    key: number,
    flight: FlightType,
}

interface StateType {
    /* from redux props mapping*/
    locations: LocationsType,
    mapType: number,
    hoveredFlight: HoveredFlightType,
    showShowcase: NullableType<FlightType>,
    hoveredCityName: string,
    lastAction: any

}

interface DispatchType {
    /* from redux actions*/
    toggleShowcase: typeof actions.toggleShowcase,
    setHoveredFlight: typeof actions.setHoveredFlight,
}

type PropsType = InputType & StateType & DispatchType;

const MOBILE_WEIGHT = 6;
class LPolyline extends Component<PropsType, LocalStateType> {

    constructor(props: PropsType) {
        super(props);

        this._flightToPath = this._flightToPath.bind(this);
        this._toggleShowcase = this._toggleShowcase.bind(this);
        this._onPolylineMouseover = this._onPolylineMouseover.bind(this);
        this._onPolylineMouseout = this._onPolylineMouseout.bind(this);
        this._hoverFlight = this._hoverFlight.bind(this);
        this.geoDes = this.geoDes.bind(this);

        this.state = {
            highlight: false,
            mobileTouchStart: null
        };

    }

    leafletGeodesicElement: any;
    leafletGeodesicElementB: any;
    leafletGeodesicElement2B: any;
    leafletGeodesicElement3B: any;
    leafletGeodesicElement2: any;
    leafletGeodesicElement3: any;

    _toggleShowcase(flight: FlightType) {
        log('toggleShowcase');
        this.props.toggleShowcase(flight);
    }

    _flightToPath(flight: FlightType) {
        return [
            {lat: this.props.locations[flight.from].lat, lng: this.props.locations[flight.from].lng},
            {lat: this.props.locations[flight.to].lat, lng: this.props.locations[flight.to].lng}
        ];
    }

    _onPolylineMouseover(e: MouseEvent) {
        //no need to connect these, read only, would cause unnecessary updates otherwise
        const state = store.getState().reducer;
        // @ts-ignore
        if (state.showCharts > -1 || state.showGlobe > -1 || state.showTableNumber > -1 || state.editFlightNumber > -1 || state.showShowcase) {
            return false;
        }

        this._hoverFlight(this.props.flight, e);
        this.setState({
            highlight: true,
            mobileTouchStart: Date.now()
        });
    }

    _onPolylineMouseout(e: any) {
        //why was this if here? With FLM lite seemed to cause some highlights to stay indefinitely
        //if (this.state.highlight) {
            this._hoverFlight(null, null);
            this.setState({
                highlight: false
            });
        //}
    }

    _hoverFlight(flight: any, e: any) {
        // console.log('hoverflight', flight, e);

        this.props.setHoveredFlight({
                flight: flight,
                hoveredFlightPosition: {
                    x: e ? e.containerPoint.x : null,
                    y: e ? e.containerPoint.y : null
                }
            }
        );
    }

    shouldComponentUpdate(nextProps: any, nextState: any) {
        const should =
            (nextProps.mapType !== GOOGLE_MAP_TYPE) &&
            ((isMobile && nextState.highlight !== this.state.highlight) ||
                (isMobile
                    && ((nextProps.hoveredFlight.flight && (nextProps.hoveredFlight.flight.id !== nextProps.flight.id))
                        || nextProps.showShowcase
                        || (nextProps.lastAction.type === SET_HOVERED_CITY && nextProps.hoveredCityName)
                    ))
                || nextProps.lastAction.type === MAP_NEXT
                || (this.getLineColorForType(nextProps.mapType) !== this.getLineColorForType(this.props.mapType))
                || (nextState.highlight !== this.state.highlight
                    //city has just been hovered and flight touches city
                    || ((nextProps.hoveredCityName !== this.props.hoveredCityName) &&
                        (nextProps.hoveredCityName && this.flightTouchesCity(nextProps.flight, nextProps.hoveredCityName)))
                    //city has just been unhovered and flight touches city
                    || ((nextProps.hoveredCityName === null && this.props.hoveredCityName !== null && this.flightTouchesCity(this.props.flight, this.props.hoveredCityName)))
                ));

        return should;
    }

    flightTouchesCity(flight: actions.FlightType, city: string) {
        return (airportToCityCountry(flight.from, this.props.locations) === city ||
            airportToCityCountry(flight.to, this.props.locations) === city
        );
    }

    getLineColorForType(mapType: number): ArcColor {
        return mapData()[mapType].color;
    }
    getLineColor(): ArcColor {
        return mapData()[this.props.mapType].color;
    }
    getOpacity(): number {
        return mapData()[this.props.mapType].opacity;
    }

    geoDes(key: string, ref: any, fromLat: any, fromLng: any, toLat: any, toLng: any, basicWeight: any, currentOpacity: any, color: any) {
        return <GeodesicLine
            key={key}
            ref={ref}
            positions={[
                [
                    fromLat,
                    fromLng
                ],
                [
                    toLat,
                    toLng
                ]
            ]}
            options={{
                weight: basicWeight,
                opacity: currentOpacity,
                color: color,
                steps: 8,
                wrap: false
            }}
            onMouseOver={(e: MouseEvent) => {
                this._onPolylineMouseover(e);
            }}
            onMouseOut={(e: MouseEvent) => {
                this._onPolylineMouseout(e);
            }}
            onClick={(e: MouseEvent) => {
                log('click')
                if (isMobile) {
                    if (this.props.hoveredFlight.flight && this.props.hoveredFlight.flight.id !== this.props.flight.id) {
                        this._onPolylineMouseout(null);
                    }

                    if (this.state.mobileTouchStart && Date.now() - this.state.mobileTouchStart > 500) {
                        this._toggleShowcase(this.props.flight);
                    } else {
                        this._onPolylineMouseover(e);
                    }
                }
            }}
        />
    }
    render() {
        log('renderLPolyline', this.props.flight.id);
        // leaflet does not have mobile onmouseout support -> must be tested at render after the next click
        if (isMobile
            && this.state.highlight
            && ((this.props.hoveredFlight.flight && (this.props.hoveredFlight.flight.id !== this.props.flight.id))
                || this.props.showShowcase
                || (this.props.lastAction.type === SET_HOVERED_CITY && this.props.hoveredCityName)
            )
        ) {
            setTimeout(() => this.setState({
                highlight: false,
                mobileTouchStart: null
            }),0);
        }

        const circleHighlight = this.flightTouchesCity(this.props.flight, this.props.hoveredCityName);
        const currentColor = this.getLineColor();
        const currentOpacity = this.getOpacity();

        const basicWeight = 1.5;

        // options update does not work in react-leaflet-geodesic
        // we need to have the reference to the element and call setStyle ourselves
        if (typeof this.leafletGeodesicElement !== 'undefined') {
            const style = {
                weight: (this.state.highlight || circleHighlight) ? 3 : basicWeight,
                opacity: currentOpacity,
                color: (this.state.highlight || circleHighlight) ? currentColor.highlight : currentColor.base,
                steps: 8,
                wrap: false
            };
            this.leafletGeodesicElement.setStyle(style) ;
            this.leafletGeodesicElement2.setStyle(style) ;
            this.leafletGeodesicElement3.setStyle(style) ;
            if (isMobile) {
                const styleMobile = {
                    weight: (this.state.highlight ? MOBILE_WEIGHT * 3 : MOBILE_WEIGHT),
                    opacity: 0,
                    color: (this.state.highlight || circleHighlight) ? currentColor.highlight : currentColor.base,
                    steps: 8,
                    wrap: false
                };
                this.leafletGeodesicElementB.setStyle(styleMobile) ;
                this.leafletGeodesicElement2B.setStyle(styleMobile) ;
                this.leafletGeodesicElement3B.setStyle(styleMobile) ;
            }
        }

        let fromLng = this.props.locations[this.props.flight.from].lng;
        let toLng = this.props.locations[this.props.flight.to].lng;
        let fromLat = this.props.locations[this.props.flight.from].lat;
        let toLat = this.props.locations[this.props.flight.to].lat;

        if (fromLng < toLng && fromLng < -100 && toLng > 100) {
            fromLng = toLng;
            fromLat = toLat;
            toLng = 360 + this.props.locations[this.props.flight.from].lng;
            toLat = this.props.locations[this.props.flight.from].lat;
        } else if (fromLng > toLng && toLng < -100 && fromLng > 100) {
            toLng = 360 + toLng;
        }

        let fromLng2 = fromLng + 360;
        let fromLat2 = fromLat;
        let toLng2 = toLng + 360;
        let toLat2 = toLat;

        let fromLng3 = fromLng - 360;
        let fromLat3 = fromLat;
        let toLng3 = toLng - 360;
        let toLat3 = toLat;

        // three geodesiclines needed, one for main coordinates, others for scrolling outside -180,180
        // for mobile lines are too thin, need thicker invisible duplicates
        return (
            <Fragment>
                {
                    this.geoDes(this.props.flight.id + 'a',
                        (component: any) => { this.leafletGeodesicElement = component; },
                        fromLat,fromLng,toLat,toLng,basicWeight,currentOpacity,currentColor.base)
                }
                {isMobile ?
                    this.geoDes(this.props.flight.id + 'a2',
                        (component: any) => { this.leafletGeodesicElementB = component; },
                        fromLat,fromLng,toLat,toLng,MOBILE_WEIGHT,0,currentColor.base)
                    : ''
                }
                {
                    this.geoDes(this.props.flight.id + 'b',
                        (component: any) => { this.leafletGeodesicElement2 = component; },
                        fromLat2,fromLng2,toLat2,toLng2,basicWeight,currentOpacity,currentColor.base)
                }
                {isMobile ?
                    this.geoDes(this.props.flight.id + 'b2',
                        (component: any) => { this.leafletGeodesicElement2B = component; },
                        fromLat2,fromLng2,toLat2,toLng2,MOBILE_WEIGHT,0,currentColor.base)
                    : ''
                }
                {
                    this.geoDes(this.props.flight.id + 'c',
                        (component: any) => { this.leafletGeodesicElement3 = component; },
                        fromLat3,fromLng3,toLat3,toLng3,basicWeight,currentOpacity,currentColor.base)
                }
                {isMobile ?
                    this.geoDes(this.props.flight.id + 'c2',
                        (component: any) => { this.leafletGeodesicElement3B = component; },
                        fromLat3,fromLng3,toLat3,toLng3,MOBILE_WEIGHT,0,currentColor.base)
                    : ''
                }
            </Fragment>

        );
    }
}

const mapStateToProps = (state: StateBaseType) => ({
    locations: state.reducer.locations,
    mapType: state.reducer.mapType,
    hoveredFlight: state.reducer.hoveredFlight,
    showShowcase: state.reducer.showShowcase,
    hoveredCityName: state.reducer.hoveredCity ? state.reducer.hoveredCity.hoveredCity : null,
    lastAction: state.lastAction
});

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => {
    return bindActionCreators<any, any>(actions, dispatch);
};

export default connect<StateType, DispatchType, InputType, StateBaseType>(mapStateToProps, mapDispatchToProps)(LPolyline);
